export default "__VITE_ASSET__989c3aba__"